import {
  containsSampleTestValue,
  filterSampleTestStrings,
} from "../components/actions/cleanup";
import { isSampleTestRow } from "../excel/mapping/sampleDataFilter";
import { validationMessages } from "../components/actions/validations";

/** Autocomplete "code - name" options, excluding demo sample rows/labels. */
export const buildSnCCodeNameOptions = (
  list: unknown[] | undefined,
  codeKey: string,
  nameKey: string,
): string[] => {
  if (!Array.isArray(list)) {
    return [];
  }
  return filterSampleTestStrings(
    list
      .filter(
        (item) =>
          item &&
          typeof item === "object" &&
          !isSampleTestRow(item as Record<string, unknown>),
      )
      .flatMap((item) => {
        const row = item as Record<string, unknown>;
        const code = row?.[codeKey] || "";
        const name = row?.[nameKey] || "";
        if (code && name) {
          return [`${code} - ${name}`];
        }
        const value = code || name;
        return value ? [String(value)] : [];
      }),
  );
};

export const buildSnCRetailItemOptions = (
  list: unknown[] | undefined,
): string[] =>
  buildSnCCodeNameOptions(list, "Item Number", "Item Description");

/** Filter building dropdown labels that contain sample markers. */
export const filterSnCBuildingOptions = (options: string[]): string[] =>
  filterSampleTestStrings(options);

/**
 * Returns an error message when any field still references demo sample data.
 * Call after mandatory/format validation in add/update flows.
 */
export const sampleTestBlockMessage = (
  ...values: unknown[]
): string | null => {
  if (values.some((value) => containsSampleTestValue(value))) {
    return validationMessages.sampleTestNotAllowed;
  }
  return null;
};
